// src/pages/Estatisticas/index.js
import React from 'react';
import ModelUsageStats from './components/ModelUsageStats';
import UsageEvolutionChart from './components/UsageEvolutionChart';
import AutomacoesStats from './components/AutomacoesStats';
import AccessByFunctionStats from './components/AccessByFunctionStats';
import UsoIAPorClienteStats from './components/UsoIAPorClienteStats';
import './Estatisticas.css';

const Estatisticas = () => {
  return (
    <div className="estatisticas-container">
      <div className="estatisticas-header">
        <h2>📊 Estatísticas de Uso do Sistema</h2>
        <p>Análise de uso dos modelos de IA e evolução temporal</p>
      </div>

      <div className="stats-grid">
        <ModelUsageStats />
        <UsageEvolutionChart />
        <AutomacoesStats />
        <AccessByFunctionStats />
        <UsoIAPorClienteStats />
      </div>
    </div>
  );
};

export default Estatisticas;